// presets.js — leichte Konstanten (ohne Farbbibliothek), damit Oberflächen sie statisch importieren können.
export const DEFAULT_SEED = '#2D4A3E';
export const DEFAULT_TERTIARY = '#C85A2E';
/** Vorschläge im Profil (Name → Leitfarbe). */
export const SEED_PRESETS = [
  { id: 'wald', hex: '#2D4A3E' },
  { id: 'fjord', hex: '#2F6A8F' },
  { id: 'sand', hex: '#9A7B4F' },
  { id: 'lavendel', hex: '#6B5B9A' },
  { id: 'terrakotta', hex: '#B4532A' },
  { id: 'moos', hex: '#5D7A2E' },
];
export const CONTRAST_LEVELS = { standard: 0, medium: 0.5, high: 1 };
